import { combineReducers } from "redux";
import { fundStructureReducer } from "./FundStructure/__redux/reducers";
import { membersReducer } from "./Members/__redux/reducers";

export const fundReducer = combineReducers({
	fundStructure: fundStructureReducer,
	members: membersReducer,
});
